import * as ReactService from "@intech/react-service";
import { IdadeAposentadoria } from "../entidades/IdadeAposentadoria";

class SimuladorAposentadoria extends ReactService.BaseService {
  constructor() {
    super("SimuladorAposentadoria");
  }

  BuscarIdadeAposentadoria = (anos: number) =>
    this.CreateRequest<IdadeAposentadoria>(ReactService.RequestType.GET, `BuscarIdadeAposentadoria/${anos}`);

  BuscarFatorAtuarialAT83 = (idadeAposentadoria: number, rentabilidadeAnual: number) =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `BuscarFatorAtuarialAT83/${idadeAposentadoria}/${rentabilidadeAnual}`);

  BuscarFatorAtuarialPrazoCerto = (mesesPrazo: number, rentabilidadeAnual: number) =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `BuscarFatorAtuarialPrazoCerto/${mesesPrazo}/${rentabilidadeAnual}`);

  CalcularSaldoAposentadoria = (cdPlano: string, idadeAposentadoria: number, rentabilidadeAnual: number, contribuicaoAdicional: number) =>
    this.CreateRequest<number>(ReactService.RequestType.GET, `CalcularSaldoAposentadoria/${cdPlano}/${idadeAposentadoria}/${rentabilidadeAnual}/${contribuicaoAdicional}`);

}

export const SimuladorAposentadoriaService = new SimuladorAposentadoria();
